import Login from '@/views/login.view.vue';

import {
  ACCOUNT_ROUTES,
  ANALYTICS_ROUTES,
  ATTRIBUTES_RANKING_ROUTES,
  BLACKLIST_ROUTES,
  BOOSTS_ROUTES,
  CONFIGURATIONS_ROUTES,
  Domain,
  DomainEnum,
  EQUALIZE_DASHBOARD_ROUTES,
  GUARDS_EXECUTOR,
  Home,
  INDEX_ROUTES,
  INSIGHTS_ROUTES,
  INSTANCES_ROUTES,
  LINKS_ROUTES,
  LoginGuard,
  LogoutGuard,
  PageNotFound,
  PROMOTIONS_ROUTES,
  ROUTER_CONSTS,
  SYNONYMS_DASHBOARD_ROUTES
} from 'playboard-core';

import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
export const ROUTER = new Router({
  mode: 'history',
  routes: [
    {
      name: ROUTER_CONSTS.routes.login,
      path: '/login',
      component: Login,
      beforeEnter: GUARDS_EXECUTOR([
        LoginGuard.execute
      ])
    }, {
      name: ROUTER_CONSTS.routes.logout,
      path: '/logout',
      beforeEnter: GUARDS_EXECUTOR([
        LogoutGuard.execute
      ])
    }, {
      name: ROUTER_CONSTS.routes.home,
      path: `/:${ ROUTER_CONSTS.params.instanceId }?`,
      component: Home,
      // FYI: route guards moved to component
      children: [
        ...INDEX_ROUTES,
        ...INSTANCES_ROUTES,
        ...ACCOUNT_ROUTES, {
          name: ROUTER_CONSTS.routes[DomainEnum.SEARCH],
          path: DomainEnum.SEARCH,
          component: Domain,
          meta: {
            domain: DomainEnum.SEARCH
          },
          children: [
            ...ANALYTICS_ROUTES,
            ...INSIGHTS_ROUTES,
            ...EQUALIZE_DASHBOARD_ROUTES,
            ...SYNONYMS_DASHBOARD_ROUTES,
            ...LINKS_ROUTES,
            ...BOOSTS_ROUTES
          ]
        }
      ]
    }, {
      name: ROUTER_CONSTS.routes.pageNotFound,
      path: '*',
      component: PageNotFound
    }
  ]
});
